var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_MAP_ZOOM = 16;

var PaQuickQuoteLocationMap = function () {
    function PaQuickQuoteLocationMap(_ref) {
        var mapsApi = _ref.mapsApi,
            coords = _ref.coords,
            getDeviceLocation = _ref.getDeviceLocation,
            address = _ref.address,
            defaultLocation = _ref.defaultLocation;

        _classCallCheck(this, PaQuickQuoteLocationMap);

        this.canChangePos = false;
        this.mapsApi = mapsApi;
        this.coords = coords;
        this.getDeviceLocation = getDeviceLocation;
        this.address = address;
        this.defaultLocation = defaultLocation;
    }

    _createClass(PaQuickQuoteLocationMap, [{
        key: 'init',
        value: function init(mountNode) {
            this.initMap(mountNode);
            this.setInitialMarkerPosition();
        }
    }, {
        key: 'initMap',
        value: function initMap(mountNode) {
            var _this = this;

            this.map = new this.mapsApi.Map(mountNode, {
                zoom: DEFAULT_MAP_ZOOM,
                center: this.getInitialMapCenter(),
                clickableIcons: false,
                streetViewControl: false,
                disableDoubleClickZoom: true,
                gestureHandling: 'cooperative',
                draggableCursor: 'pointer',
                disableDefaultUI: true
            });
            return new Promise(function (resolve) {
                return _this.onceIdle(function () {
                    _this.mapsApi.event.trigger(_this.map, 'resize');
                    resolve();
                });
            });
        }
    }, {
        key: 'onceIdle',
        value: function onceIdle(action) {
            this.mapsApi.event.addListenerOnce(this.map, 'idle', action);
        }
    }, {
        key: 'setInitialMarkerPosition',
        value: function setInitialMarkerPosition() {
            if (this.areCoordsProvided()) {
                this.setMarkerPosition({ lat: this.coords.latitude, lng: this.coords.longitude });
            } else {
                this.setDeviceGeolocation();
            }
        }
    }, {
        key: 'initMarker',
        value: function initMarker() {
            this.marker = new this.mapsApi.Marker({
                map: this.map,
                draggable: false,
                animation: this.mapsApi.Animation.DROP,
                cursor: 'url(//maps.gstatic.com/mapfiles/openhand_8_8.cur) 8 8, default'
            });
        }
    }, {
        key: 'setMarkerPosition',
        value: function setMarkerPosition(position) {
            this.coords.latitude = position.lat;
            this.coords.longitude = position.lng;
            if (!this.marker) {
                this.initMarker();
            }
            this.marker.setPosition(position);
        }
    }, {
        key: 'areCoordsProvided',
        value: function areCoordsProvided() {
            return this.coords && this.coords.latitude && this.coords.longitude;
        }
    }, {
        key: 'getInitialMapCenter',
        value: function getInitialMapCenter() {
            if (this.coords && this.coords.latitude && this.coords.longitude) {
                return { lat: this.coords.latitude, lng: this.coords.longitude };
            }
            return this.defaultLocation;
        }
    }, {
        key: 'setDefaultLocation',
        value: function setDefaultLocation() {
            var defaultGeoLocation = this.defaultLocation;
            this.map.setCenter(defaultGeoLocation);
            this.setMarkerPosition(defaultGeoLocation);
            var position = {
                coords: {
                    latitude: defaultGeoLocation.lat,
                    longitude: defaultGeoLocation.lng
                }
            };
            this.getDeviceLocation({
                position: position
            });
        }
    }, {
        key: 'setDeviceGeolocation',
        value: function setDeviceGeolocation() {
            var _this2 = this;

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    var latLong = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                    _this2.map.setCenter(latLong);
                    _this2.setMarkerPosition(latLong);
                    _this2.getDeviceLocation({
                        position: position
                    });
                }, function () {
                    _this2.setDefaultLocation();
                });
            } else {
                this.setDefaultLocation();
            }
        }
    }]);

    return PaQuickQuoteLocationMap;
}();

export default PaQuickQuoteLocationMap;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/quickquote/pa/directives/LocationMap/PaQuickQuoteLocationMap.js
// module id = 2189
// module chunks = 0